import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import TempIndex from "../../TempIndex";

export default function MoreInfo() {
  const { state } = useLocation();
  //const { data } = state;
  //   const { data } = state;
  return (
    <>
      <div class="container">
        <h2>Hello man</h2>
        <h2>{state[0]}</h2>
      </div>
    </>
  );
}
